import styled from 'styled-components';

export const WrapperListMembers = styled.div`
	overflow: auto;
	flex: 1;
`;